import { ResponseError } from '@backstage/errors';
import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

export type PmasRequest = {
  discoveryApi: DiscoveryApi;
  fetchApi: FetchApi;
  method: string;
  path: string;
  body?: unknown;
  responseType?: 'json' | 'text' | 'response' | 'blob';
  signal?: AbortSignal;
};

export async function submitRequest<T = unknown>({
  fetchApi,
  discoveryApi,
  path,
  method,
  body,
  responseType = 'json',
  signal,
}: PmasRequest): Promise<T> {
  const url = `${await discoveryApi.getBaseUrl('pmas')}${path}`;

  const headers: Record<string, string> = {};

  // Only set content-type when sending a body (POST/PUT/PATCH)
  const hasBody = body !== undefined && body !== null;
  if (hasBody) {
    headers['content-type'] = 'application/json';
  }

  const requestBody =
    typeof body === 'object' && body !== null
      ? JSON.stringify(body)
      : (body as any);

  const response = await fetchApi.fetch(url, {
    method,
    headers,
    body: hasBody ? requestBody : undefined,
    signal,
  });

  if (!response.ok) {
    throw await ResponseError.fromResponse(response);
  }

  if (responseType === 'response') {
    return response as unknown as T;
  }
  if (responseType === 'blob') {
    return (await response.blob()) as unknown as T;
  }
  if (responseType === 'text') {
    return (await response.text()) as unknown as T;
  }
  return (await response.json()) as T;
}
